import { useState } from 'react';
import { Plus, RefreshCw, Loader2 } from 'lucide-react';
import { useAgents, useReload } from '../hooks/useAgents';
import { AgentCard } from '../components/AgentCard';
import { AgentEditor } from '../components/AgentEditor';
import type { AgentData } from '../lib/api';

export function AgentsPage() {
  const { data: agents, isLoading } = useAgents();
  const reload = useReload();
  const [editing, setEditing] = useState<AgentData | null | 'new'>(null);

  return (
    <div>
      {/* Toolbar */}
      <div className="flex items-center gap-2 mb-4">
        <button
          onClick={() => setEditing('new')}
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-accent hover:bg-accent-2 text-white rounded-lg transition-colors"
        >
          <Plus className="w-3.5 h-3.5" />
          New Agent
        </button>
        <button
          onClick={() => reload.mutate()}
          disabled={reload.isPending}
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-zinc-400 border border-border rounded-lg hover:border-zinc-500 transition-colors disabled:opacity-50"
        >
          {reload.isPending ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
          Reload
        </button>
        <div className="flex-1" />
        <span className="text-[11px] text-zinc-600">
          {agents?.length ?? 0} agent{(agents?.length ?? 0) !== 1 ? 's' : ''}
        </span>
      </div>

      {/* Grid */}
      {isLoading ? (
        <div className="flex items-center justify-center py-20 text-zinc-600">
          <Loader2 className="w-5 h-5 animate-spin" />
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {agents?.map(a => (
            <AgentCard key={a.name} agent={a} onClick={() => setEditing(a)} />
          ))}
        </div>
      )}

      {/* Editor Modal */}
      {editing !== null && (
        <AgentEditor
          agent={editing === 'new' ? null : editing}
          onClose={() => setEditing(null)}
        />
      )}
    </div>
  );
}
